<style lang="stylus" scoped>
.describe 
  width 908px;
  height 670px;
  margin-top 25px
  background url('../../../../../static/img/helpPoor/bg5.png') no-repeat;
  color #fff
  .tit
    font-size 30px;
    text-align center 
  .list
    height 244px
    margin-top 80px
    display flex
    .list-item
      text-align center
      width 250px
      height 244px
      background url('../../../../../static/img/helpPoor/bg2.png') no-repeat center
      margin 0 25px
      padding-top 80px
      box-sizing border-box
    .num
      color #FFDD01
      font-size 30px
    .word
      margin-top 30px
      font-size 18px
  .chart
    margin-top 40px
    display flex
    div
      width 50%
      padding-left 25px
      box-sizing border-box
      .tit
        font-size 20px
</style>

<template>
  <div class="describe">
    <p class="tit">广西田阳新靖田农产品贸易有限公司</p>
    <div class="list">
      <div class="list-item">
        <p class="num">510吨</p>
        <p class="word">带动贫困户电商产品产量</p>
      </div>
      <div class="list-item">
        <p class="num">2585305</p>
        <p class="word">帮扶总额(元)</p>
      </div>
      <div class="list-item">
        <p class="num">184</p>
        <p class="word">带动贫困户数(户)</p>
      </div>
    </div>
    <div class="chart">
      <div>
        <p class="tit">带动贫困户电商产品</p>
        <v-two-bar></v-two-bar>
      </div>
      <div>
        <p class="tit">带动贫困户</p>
        <v-line></v-line>
      </div>
    </div>
  </div>
</template>

<script>
import twoBar from 'components/helpPoor/twoBars'
import line from 'components/helpPoor/line'
export default {
  data() {
    return {
    }
  },
  components: {
    'v-two-bar': twoBar,
    'v-line': line
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?ec0bd060